/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_SAL_SALARIES_ITEM = {
  id: 'salaries_sidebar',
  screenId: 'lab-sal-salaries',
  label: 'Salarios',
  description: 'Importe acordado por empleado, período y liquidación.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás cuánto corresponde pagarle a cada empleado en un período y número de liquidación (por ejemplo sueldo de enero, 1ra quincena, SAC). Ese importe se usa después al pagar desde Finanzas → Pagos.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Creá el período en Laboral → Salarios → Periodos.',
          'El empleado debe existir en Laboral → Empleados.',
        ],
      },
      {
        title: 'Paso 1 — Filtrar la lista',
        fields: [
          { label: 'Empleado', description: 'Buscador por nombre (mínimo 3 caracteres). Opcional.' },
          { label: 'Periodo', description: 'Todos o un período habilitado concreto.' },
          { label: 'Nº liq.', description: 'Número de liquidación dentro del período (1 = primera, 2 = segunda, etc.). Opcional.' },
          { label: 'Salarios habilitados', description: 'Marcado por defecto; desmarcá para ver deshabilitados.' },
        ],
        paragraphs: ['La lista se actualiza al cambiar los filtros. Podés exportarla.'],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: CUIL, Nombre, Nº liq., Salario, Descripción, Habilitado, Prueba.',
          'Lápiz — editar. Ícono rojo — eliminar (pide confirmación).',
        ],
      },
      {
        title: 'Paso 3 — Nuevo salario',
        intro: 'Botón +. Campos:',
        fields: [
          { label: 'Empleado', description: 'Buscador obligatorio.' },
          { label: 'Periodo', description: 'Solo períodos habilitados. Al elegir uno puede completarse la descripción.' },
          { label: 'Nº liquidación', description: 'Entero ≥ 1. Default 1. Permite varias liquidaciones en el mismo período (quincenas, SAC).' },
          { label: 'Salario', description: 'Importe acordado (≥ 0). Moneda obligatoria.' },
          { label: 'Descripción', description: 'Opcional al crear; obligatoria al editar.' },
          { label: 'Habilitado / Prueba', description: 'Desmarcá Habilitado para excluir de pagos. Prueba marca liquidaciones de ensayo.' },
        ],
        paragraphs: [
          'No puede repetirse la combinación empleado + período + nº liquidación + tipo prueba.',
        ],
      },
      {
        title: 'Paso 4 — Editar o eliminar',
        bullets: [
          'En edición no cambiás empleado ni período; sí monto, moneda, nº liquidación, descripción y casillas.',
          'Eliminar: si ya hubo pagos imputados, no se permite. Si hubo imputaciones anuladas, el salario se desactiva (baja lógica).',
        ],
      },
      {
        title: 'Relación con pagos',
        paragraphs: [
          'El pago al empleado se registra en Finanzas → Pagos, imputando a destino «Salario» y eligiendo el empleado y el salario pendiente.',
        ],
      },
    ],
  },
}
